import { EyeOutlined } from '@ant-design/icons';
import { Trans } from '@lingui/macro';
import { Col, Row } from 'antd';
import NotificationActions from 'bukku/redux/Notification/actions';
import React from 'react';
import { NotificationType } from '../../enums/NotificationType';
import { history, store } from '../../redux/store';
import { IconFont } from '../IconFont';

const {
    openModal,
} = NotificationActions;

export default function NotificationTitle({notificationData}) {
    const {
        // content,
        content_type,
        // created_at,
        // id,
        // is_read,
        // subtitle,
        title,
        url,
    } = notificationData;

    const onLinkIconClick = () => {
        if (url) {
            if (url.startsWith('/'))
                history.push(url);
            else
                window.open(url, '_blank');
        }

        if (content_type === NotificationType.table)
            store.dispatch(openModal(notificationData, false));
    };

    switch (content_type) {
        case NotificationType.link:
            return (
                <Row justify="space-between" align="start">
                    <Col flex="1 0">
                        <strong>
                            {title || <Trans>New Notification</Trans>}
                        </strong>
                    </Col>
                    <Col flex="0 0 auto">
                        <IconFont
                            type="icon-new-tab"
                            className="hoverable-icon grey new-tab-icon"
                            onClick={onLinkIconClick}
                            style={{
                                fontSize: '21px',
                            }}
                        />
                    </Col>
                </Row>
            );
        case NotificationType.table:
            return (
                <Row justify="space-between" align="middle">
                    <Col>
                        {title || <Trans>New Notification</Trans>}
                    </Col>
                    <Col>
                        <EyeOutlined
                            className="hoverable-icon grey"
                            onClick={onLinkIconClick}
                            style={{
                                fontSize: '18px',
                            }}
                        />
                    </Col>
                </Row>
            );
        default:
            return (
                <div>
                    {title || <Trans>New Notification</Trans>}
                </div>
            );
    }
}
